import DateFilter from "./date-filter";

export default function CreatedDateFilter({dateCreatedStart,
    dateCreatedEnd, onChange} : any) {    
    return (
        <DateFilter label="Date Created" startDate={dateCreatedStart} endDate={dateCreatedEnd} onChange={onChange}/>
    )
}